import { useState } from 'react'
import FilterProps from 'types/FilterProps'
import ReportFilter from 'components/ReportFilter'
import useInit from './hooks/useInit'
import useLoadFilterBar from './hooks/useLoadFilterBar'
import ChildFilterErrors from 'types/ChildFilterErrors'

interface ReportFilterBarProps {
  id: number
  setFilterParam: Function
  mode?: string
  parentFilterParams?: any
  isLoaded?: Function
  setFilterChangeTime?: Function
  setChildFilterErrors: (callback: (prev: ChildFilterErrors) => ChildFilterErrors) => void
  setLoadedFilterCount: React.Dispatch<React.SetStateAction<number | null>>
}

const ReportFilterBar: React.FunctionComponent<ReportFilterBarProps> = (props: ReportFilterBarProps) => {

  const [filters, setFilters] = useState<any>([])
  const [loadedCounter, setLoadedCounter] = useState<number>(0)
  const [isLoaded, setIsLoaded] = useState<string>('')

  useInit({
    id: props.id,
    mode: props.mode,
    setFilters,
    isLoaded: props.isLoaded,
    setLoadedFilterCount: props.setLoadedFilterCount
  })

  useLoadFilterBar({
    isLoaded,
    loadedCounter,
    setLoadedCounter,
    filters,
    setLoadedFilterCount: props.setLoadedFilterCount,
    isLoadedFunc: props.isLoaded,
  })

  return (
    <>
      {(filters.length > 0) && <div className={((props.mode === 'page') ? 'page-filter ' : '') + 'filter-bar'}>
        {filters.map((filter: FilterProps) => {
          return <ReportFilter id={filter.id} name={filter.name} param={filter.param} parentFilterId={filter.parent_filter_id} isMulti={filter.is_multi === 1} displaySelectAll={filter.display_select_all === 1} selectAllIsDefault={filter.select_all_is_default === 1} selectAllOptionsLabel={filter.select_all_label} selectAllOptionsValue={filter.select_all_value} setFilterParam={props.setFilterParam} parentFilterParams={props.parentFilterParams} isLoaded={setIsLoaded} setFilterChangeTime={props.setFilterChangeTime} setChildFilterErrors={props.setChildFilterErrors} />
        })}
      </div>}
    </>
  )
}

export default ReportFilterBar